
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { LoginService } from 'src/app/api/authentication';


@Injectable()
export class UserGuard implements CanActivate, CanLoad {

    constructor(
        private loginService: LoginService,
        private router: Router
        ) { };

    canActivate(): boolean {
        let acesso = this.loginService.isUser;
        if(acesso){
            return true;
        }
        if (!acesso) {
            this.router.navigate(['/login']);
        }
        return false
    };

    canLoad(): boolean {
      let acesso = this.loginService.isUser;
      if(acesso){
          return true;
      }
      if (!acesso) {
          this.router.navigate(['/login']);
      }
      return false
  };
}
